<template>
    <PageContainer>
        <PageHeader>
            {{ $t('issueLog.delivered.page_title') }}
        </PageHeader>

        <SearchPanel
            :search="search"
            url="/issueLogs/delivered"
            :only="['logs', 'search']"
        />

        <base-table>
            <template #thead>
                <th>{{ $t('issueLog.customer_name') }}</th>
                <th>{{ $t('issueLog.customer_lastname') }}</th>
                <th>{{ $t('issueLog.customer_document') }}</th>
                <th>{{ $t('issueLog.permission_id') }}</th>
                <th>{{ $t('issueLog.issue_type') }}</th>
                <th>{{ $t('issueLog.user_email') }}</th>
                <th></th>
            </template>
            <tr v-for="log in pagination.data" class="align-middle" :key="log.id">
                <td>{{ log.customer_name }}</td>
                <td>{{ log.customer_lastname }}</td>
                <td>{{ log.customer_document }}</td>
                <td>{{ log.permission_id }}</td>
                <td>{{ $t('issueLog.type.'+log.issue_type) }}</td>
                <td>{{ log.user?.email }}</td>
                <td class="text-end">
                    <DevolutionButton :customerUuid="log.customer_uuid" class="btn-sm me-1" />
                    <TicketButton class="btn-sm me-1" :href="`/issueLogs/${log.id}/ticket`"/>
                    <PreviewButton class="btn-sm" :href="`/issueLogs/`+log.id"/>
                </td>
            </tr>
        </base-table>

        <Pagination
            :pagination="pagination.pagination"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import BaseTable from "@/components/elements/BaseTable.vue";
import Pagination from "@/components/elements/Pagination.vue";
import type {PaginatedResponse, IssuedLogInterface} from "@/components/helpers/Interfaces.ts";
import {usePagination} from "@/Composable/usePagination.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import PreviewButton from "@/components/buttons/PreviewButton.vue";
import SearchPanel from "@/components/elements/SearchPanel.vue";
import TicketButton from "@/components/buttons/TicketButton.vue";
import DevolutionButton from "@/components/buttons/DevolutionButton.vue";

const { logs, search = null } = defineProps<{
    logs: PaginatedResponse<IssuedLogInterface>,
    search?: string
}>()

const pagination = usePagination<IssuedLogInterface>(logs)
</script>

<style scoped>

</style>
